// The hard-coded featured petition cross-promoted by this experiment. Excluded from the toast on
// its own petition-details page (behavior 5).
export const FEATURED_PETITION_SLUG = 'petition-to-stop-the-early-release-from-jail-of-pc-andrew-harper-s-killers';

// Scroll depth (percentage of the scrollable height) at which the toast becomes eligible to show.
export const SCROLL_DEPTH_THRESHOLD_PERCENT = 90;

// Route ids (see each page's routes.config) on which the toast may appear.
export const QUALIFYING_ROUTE_IDS = ['homepage', 'search', 'petition-details'] as const;

// sessionStorage key for the once-per-session "toast already shown" flag.
export const SESSION_FLAG_STORAGE_KEY = 'ukSurgingPetitionToastShown';
